import { Component, HostListener } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  upButton: any;

  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll() {

    this.upButton = document.getElementById("btn-back-to-top");

    if (this.upButton != null) {
      this.upButton.addEventListener("click", this.backToTop);

      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        this.upButton.classList.add("active");
      } else {
        this.upButton.classList.remove("active");
      }
    }
 
  }

  // When the user clicks on the button, scroll to the top of the document

  backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
